export enum ProductManufacturerField {
  Manufacturer = 1,
  ManufacturerType = 2,
  IsPrimary = 3
}

(ProductManufacturerField as any).__typeName = 'ProductManufacturerField';
